const now = new Date();
const talks = [
  {
    id: "2020-01",
    title: "Wandel der Alpinen Gefahren durch Umwelteinflüsse",
    image: "/assets/talk-1.png",
    year: "2020",
    date: "2020-09-22",
    time: "19:30",
    speakers: [
      {
        name: "Prof. Michael Krautblatter",
        image: "/assets/speaker-2020-01-03.jpg",
      },
      { name: "Theo Maurer", image: "/assets/speaker-2020-01-02.jpg" },
      { name: "Dr. Christoph Mayer", image: "/assets/speaker-2020-01-01.jpg" },
      {
        name: "Dr. Herbert Mayer (Moderator)",
        image: "/assets/speaker-2020-01-04.jpg",
      },
    ],
    homepage: null,
    zoom: "https://us02web.zoom.us/webinar/register/WN_ju2QaV0wTNOai53WBmgE_w",
    youtube: "https://youtu.be/ofmPyNE3gHw",
    description:
      "**Hochvogel — Vorhersage und Frühwarnung von alpinen Naturgefahren**\nProf. Dr. rer.nat. Michael Krautblatter (TU München)\n\n**Die Aufgaben der Bergretter bei Naturereignissen in der Schweiz**\nTheo Maurer (Chef Ausbildung, Alpine Rettung Schweiz)\n\n**Alpine Gefahren im Klimawandel — Gletscherentwicklung und Alpinismus**\nDr. rer. nat. Christoph Mayer (Bayerische Akademie der Wissenschaften)",
  },
  {
    id: "2020-03",
    title:
      "Der X + 1te Sinn — Wie neue Technologien unsere Fähigkeiten erweitern",
    image: "/assets/venue-1.png",
    year: "2020",
    date: "2020-10-20",
    time: "19:30",
    speakers: [
      { name: "Sascha Hardegger", image: "/assets/speaker-2020-03-01.jpg" },
      { name: "Thomas Lübcke", image: "/assets/speaker-2020-03-02.jpg" },
      { name: "Bernd Zehetleitner", image: "/assets/speaker-2020-03-03.jpg" },
      {
        name: "Thomas Griesbeck und Florian Abt (Moderation)",
        image: "/assets/speaker-2020-03-04.jpg",
      },
    ],
    homepage: null,
    zoom: "https://us02web.zoom.us/webinar/register/WN_0sROre1lRrugb1l5QsmpvQ",
    youtube: "https://www.youtube.com/watch?v=9sYU89zebrA",
    description:
      "**Projekt Rega–Drohne, Anspruch und Realität im Gebirge**\nSascha Hardegger (Schweizerische Rettungsflugwacht Rega, Programmleiter Technologie und Innovation, Mitglied des Kaders)\n\n**Drei Zukunftstechnologien für die Maritimen Such und Rettungsdienst**\nThomas Lübcke (Die Seenotretter — DGzRS, Leiter Research & Development)\n\n**Radarsuche aus der Luft — RECCO SAR Helikopter Detektor**\nBernd Zehetleitner (Reccoinstructor)",
  },
  {
    id: "2020-02",
    title: "From hot to steep to cold — mountain rescue in North America",
    image: "/assets/venue-1.png",
    year: "2020",
    date: "2020-10-27",
    time: "19:30",
    speakers: [
      {
        name: "Drew Harrell, M.D, FAEMS",
        image: "/assets/speaker-2020-02-01.jpg",
      },
      { name: "Jack Hoeflich", image: "/assets/speaker-2020-02-02.jpg" },
      {
        name: "Jennifer Dow, MD FACEP, FAWM",
        image: "/assets/speaker-2020-02-03.jpg",
      },
      {
        name: "Dr. Christian Nußbickel (Moderator)",
        image: "/assets/speaker-2020-02-04.jpg",
      },
    ],
    homepage: null,
    zoom: "https://us02web.zoom.us/webinar/register/WN_LwQt-tNEQQOCpzH6SlMSGQ",
    youtube: "https://youtu.be/9ff7OojlSPA",
    description:
      "**Drew Harrell, M.D, FAEMS**\nUNM Department of Emergency Medicine UNM EMS Medical Direction Consortium Director, Center for Law Enforcement Operational Medicine TEMS Physician & Medical Director, Bernalillo Co. Sheriff's Department Medical Director, New Mexico State Police & State SAR Medcial Director, Albuquerque Police Dept. Special Operations Division/TEMS Medical Director, Grand Canyon National Park\n\n**Jack Hoeflich**\nEmergency Services Program Manager, Yosemite NP\n\n**Jennifer Dow, MD FACEP, FAWM**\nMedical Doctor, Emergency medicine Medical director Denali National Park, Alaska",
  },
  {
    id: "2020-04",
    year: "2020",
    title:
      "Lebensrettende Maßnahmen am alpinen Unfallort — kritisch beleuchtet",
    image: "/assets/venue-1.png",
    date: "2020-11-03",
    time: "19:30",
    speakers: [
      {
        name: "Dr. Martin Fiedermutz (Vortrag und Moderation)",
        image: "/assets/speaker-2020-04-01.jpg",
      },
      {
        name: "Dr. Markus Thaler",
        image: "/assets/speaker-2020-04-02-2.jpg",
      },
      {
        name: "Dr. Herbert Mayer",
        image: "/assets/speaker-2020-04-03.jpg",
      },
    ],
    homepage: null,
    zoom: "https://us02web.zoom.us/webinar/register/WN_i_P7Q0N1T2yzXNw5O-3f_A",
    youtube: "https://youtu.be/5XAh9yrUPwQ",
    description:
      "**Intubation statt supraglottischer Atemwegshilfen — Erste Wahl auch für Ungeübte?**\nDr. Martin Fiedermutz (Zentrum für Gebirgsmedizin an der Klinik Immenstadt, Chefarzt der Abteilung Anästhesie und Intensivmedizin Klinik Immenstadt)\n\n**Kreislaufstabilisierung im Hochgebirge — Was ist anders?**\nDr. Markus Thaler (Anästhesie Oberarzt Universitätsklinik in Innsbruck; Leitender Notarzt Christophorus 1)\n\n**Immobilisation der Wirbelsäule — lebensrettend oder lebensgefährlich?**\nDr. Herbert Mayer (Zentrum für Gebirgsmedizin an der Klinik Immenstadt; Regionalarzt der Bergwacht Allgäu; Chefarzt Unfallchirurgie und Orthopädische Chirurgie Klinik Immenstadt)",
  },
].map((talk) => {
  var speakerNames = [];
  var speakerImages = [];
  var date = new Date(talk.date);
  var eod = date.setHours(23,59,59,999);

  (talk.speakers || {}).forEach((speaker) => {
    if (speaker.name && speaker.name != "") {
      speakerNames.push(speaker.name);
    }
    if (speaker.image && speaker.image != "") {
      speakerImages.push(speaker.image);
    }
  });

  talk.speakerNames = speakerNames;
  talk.speakerImages = speakerImages;

  talk.localDate = date.toLocaleDateString();
  talk.pastEvent = now > eod;

  return talk;
});

const Data = {
  install(Vue) {
    Vue.prototype.$_talks = function() {
      return talks;
    };

    Vue.prototype.$_talk = function(id) {
      return talks.find((talk) => {
        return talk.id === id;
      });
    };
  },
};

export default Data;
